// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupContent_wrapper__1bTYO","list":"PopupContent_list__6OBD_","item":"PopupContent_item__hFyzQ","noRepliesText":"PopupContent_noRepliesText__2QFRc"};